<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3.5" />
    <path d="M12 10.2856V11.9999" stroke-linecap="round" />
    <path d="M12 12L13.1429 13.1429" stroke-linecap="round" />
    <path
      d="M12 3.5C12 3.77614 11.7761 4 11.5 4H4.5C4.22386 4 4 3.77614 4 3.5V2.5C4 2.22386 4.22386 2 4.5 2H5.5C5.77614 2 6 1.77614 6 1.5V0.5C6 0.223858 6.22386 0 6.5 0H9.5C9.77614 0 10 0.223858 10 0.5V1.5C10 1.77614 10.2239 2 10.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5Z" />
    <path
      d="M3 4C2.44772 4 2 4.44772 2 5V14C2 14.5523 2.44772 15 3 15H6.5C6.77614 15 7 15.2239 7 15.5C7 15.7761 6.77614 16 6.5 16H3C1.89543 16 1 15.1046 1 14V5C1 3.89543 1.89543 3 3 3V4ZM6.5 9.5C6.77614 9.5 7 9.72386 7 10C7 10.2761 6.77614 10.5 6.5 10.5H4.5C4.22386 10.5 4 10.2761 4 10C4 9.72386 4.22386 9.5 4.5 9.5H6.5ZM8.5 6.5C8.77614 6.5 9 6.72386 9 7C9 7.27614 8.77614 7.5 8.5 7.5H4.5C4.22386 7.5 4 7.27614 4 7C4 6.72386 4.22386 6.5 4.5 6.5H8.5ZM13 3C14.1046 3 15 3.89543 15 5V6.5C15 6.77614 14.7761 7 14.5 7C14.2239 7 14 6.77614 14 6.5V5C14 4.44772 13.5523 4 13 4V3Z" />
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'automated-order'
})
</script>
